const arrayMerge = {};

// 根據 id 合併其它所有鍵值為 array
// input:
// [{author: "AAA", authorId: "PER1", id: "PUB001"}, {author: "BBB", authorId: "PER2", id: "PUB001"}]
// return:
// [{author: ["AAA", "BBB"], authorId: ["PER1", "PER2"],
// authors:[{author:"AAA", authorId:"PER1"}, {author:"BBB", authorId:"PER2"}], id: "PUB001"}]
const arrayMergeAuthors = (input, key) =>
  input.reduce((re, obj) => {
    const item = re.find((o) => o[key] === obj[key]);
    if (item) {
      item.authors = obj.authorId
        ? item.authors.concat({
            author: obj.author,
            authorId: obj.authorId,
          })
        : item.authors;

      item.authorId = obj.authorId
        ? item.authorId.concat(obj.authorId)
        : item.authorId;
      item.author = obj.author ? item.author.concat(obj.author) : item.author;
    } else {
      // eslint-disable-next-line no-param-reassign
      obj.authors = [{ author: obj.author, authorId: obj.authorId }];

      // eslint-disable-next-line no-param-reassign
      obj.authorId = obj.authorId ? [obj.authorId] : [];
      // eslint-disable-next-line no-param-reassign
      obj.author = obj.author ? [obj.author] : [];
      re.push(obj);
    }
    return re;
  }, []);

// 根據 id 合併其它所有鍵值為 array
// input: 'graph', 'startDate', 'authorName', 'type'
// [{graph: "全臺詩", startDate: "PER1", authorName: "作者名", type: '詩文作品', source: '作品名1', typeId: 'ART111'},
// {graph: "全臺詩", startDate: "PER1", authorName: "作者名", type: '詩文作品', source: '作品名2', typeId: 'ART222'},]
// return:
// [{graph: "全臺詩", startDate: "PER1", authorName: "作者名", type: '詩文作品', source: '作品名1', typeId: 'ART111',
// mergedList: {source: ['作品名1', '作品名2'], typeId: ['ART111', 'ART222']}}]
const arrayMergeTimeline = (
  input,
  keys = [],
  mergeKeys = [],
  mergedName = "mergedList"
) =>
  input.reduce((re, obj) => {
    const item = re.find((o) => {
      let match = true;

      // 不存在此 property
      keys.forEach((key) => {
        // not found
        if (Object.keys(obj).indexOf(key) < 0) {
          match = false;
        }
        if (Object.keys(o).indexOf(key) < 0) {
          match = false;
        }

        // not the same
        if (o[key] !== obj[key]) {
          match = false;
        }
      });
      return match ? o : null;
    });

    const mergedObj = (inObj, inKeys) => {
      const mObj = {};
      inKeys.forEach((k) => {
        mObj[k] = inObj[k];
      });
      return mObj;
    };

    if (item) {
      item[mergedName] = item[mergedName].concat(mergedObj(obj, mergeKeys));
    } else {
      // eslint-disable-next-line no-param-reassign
      obj[mergedName] = [mergedObj(obj, mergeKeys)];
      re.push(obj);
    }
    return re;
  }, []);

arrayMerge.author = arrayMergeAuthors;
arrayMerge.timeline = arrayMergeTimeline;

export default arrayMerge;
